<template>
  <div class="organizationMain">
    <div class="rightAppManager">
      <!-- 顶部导航栏 -->
      <el-row class="AppManager-title" v-if="$route.path !== '/organization' || isAppenTitle">
        <breadCrubm :navMenu="navMenu">
        </breadCrubm>
      </el-row>
      <!-- 内容区域 -->
      <div class="AppManager-list">
        <div class="AppManager-list-todo">
          <el-button
            v-for="btn in todoList"
            :key="btn.id"
            size="mini"
            :type="btn.type"
            @click="dealBtn(btn.id)"
            >{{ btn.text }}</el-button
          >
        </div>
        <ul class="AppManager-list-title">
          <li></li>
          <li>组织名称</li>
          <li>是否流程显示</li>
          <li>组织类型</li>
          <li>组织管理员</li>
          <li>主管</li>
          <li>排序</li>
          <li>是否激活</li>
          <li>操作</li>
        </ul>
        <div class="scrollArea">
          <organization-child
            ref="organizationChildOps"
            @del-edit="handleDelEdit"
            @check="(list)=>{organizationIdArr=list}"
          >
          </organization-child>
        </div>
      </div>
    </div>
    <!-- 批量添加部门 -->
    <org-import v-model:isView="popupBatchAddDept"></org-import>
    <!-- 组织的操作 -->
    <org-set 
      ref="orgSet"
      @success="orgSetSuccess"
    />
  </div>
</template>

<script>
import { deleteorganization } from '@/port/admins/organizationUser'
import organizationChild from './organizationChild'
import treeMixins from './common/common.js'
import { getdepttiplist } from '@/port/admins/organizationUser'
import { defineAsyncComponent } from 'vue'
export default {
  name: 'organizationMain',
  data () {
    return {
      // 顶部菜单栏
      navMenu: ['组织管理'],
      // 按钮列表
      todoList: [
        {
          id: 1,
          type: 'primary',
          text: '添加组织',
        },
        {
          id: 2,
          type: '',
          text: '批量创建组织',
        },
        {
          id: 3,
          type: '',
          text: '编辑选中组织',
        },
        {
          id: 4,
          type: '',
          text: '删除选中组织',
        },
      ],
      //  打开批量导入部门的弹窗
      popupBatchAddDept: false,
      // 组织类型
      typeList: [],
      typeLoading: false,
      // 多选选中的列表
      organizationIdArr: [],
      currentNode: null
    }
  },
  props: {
    isAppenTitle: {
      type: Boolean,
      default: true
    },
  },
  created () {
    // 远程获取组织类型
    this.getTyle()
  },
  components: {
    organizationChild,
    breadCrubm: defineAsyncComponent(() => import('./common/breadCrubm.vue')),
    orgImport: defineAsyncComponent(() => import('./common/orgImport.vue')),
    orgSet: defineAsyncComponent(() => import('./common/orgSet'))
  },
  mixins: [treeMixins],
  watch:{
  },
  methods: {
    orgSetSuccess () {
      if (this.currentNode) {
        this.$refs.organizationChildOps.nodeRefresh(this.currentNode)
        this.currentNode = null
      } else {
        this.$refs.organizationChildOps.refreshTree()
      }
    },
    // 获取组织类型
    async getTyle (val) {
      const obj = {
        curpage: 1,
        pagesize: 9999
      }
      if (val) obj.name = val
      const res = await getdepttiplist(obj)
      if (res.code === 0) {
        this.typeList = res.data
      }
    },
    // 组织操作
    handleDelEdit (value, istype, node) {
      if (node) {
        this.currentNode = node
      }
      // 0是快速创建下级组织 1 是编辑  2是删除
      switch(istype) {
        case 0: {
          // 新建下级组织
          const obj = {
            name: '',
            pid: value.organizationId,
            pName: value.name,
            orders: 0,
            status: 1,
            admintor: [],
            muser: [],
            type: ''
          }
          this.$refs.orgSet.open({
            data: obj,
            isLevelAdd: true,
            title: `新增${value.name}下级组织`
          })
          break
        }
        case 1: {
          // 编辑
          const obj = {
            name: value.name,
            orders: value.orders,
            pid: value.pid,
            pName: value.pName || '',
            status: value.status,
            type: value.type,
            organizationId: value.organizationId,
            looktype: value.looktype,
            muser: value.muser ? JSON.parse(value.muser) : [],
            admintor: value.admintor ? JSON.parse(value.admintor) : []
          }
          this.$refs.orgSet.open({
            data: obj,
            isEdit: true,
            title: '编辑组织'
          })
          break
        }
        case 2: {
          const tip = `确定要删除${value && value.name ? '"'+ value.name + '"' : '所选'}组织?`
          // 删除
          this.$confirm(tip, '提示', {
            confirmButtonClass: 'el-button--yeprimary',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const oneOrganId = value ? value.organizationId : this.organizationIdArr.idArr
            deleteorganization({ organizationId: oneOrganId }).then(res => {
              if (res.code == 0) {
                this.$message({ type: "success", message: "删除成功!" });
                // 刷新数据
                this.orgSetSuccess()
              } else {
                this.$message({ type: "info", message: res.msg });
              }
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
          break
        }
      }
    },
    // 操作按钮
    dealBtn (id) {
      // 1 添加组织 2 批量创建组织 3 编辑选中组织 4 删除选中组织
      if (id === 1) {
        this.$refs.orgSet.open()
      } else if (id === 2) {
        this.popupBatchAddDept = true
      } else if (id === 3) {
        if(this.organizationIdArr.idArr && this.organizationIdArr.idArr.length > 0) {
          this.$refs.orgSet.open({
            data: this.organizationIdArr,
            title: '批量编辑组织',
            isBatchEdit: true
          })
        } else {
          this.$message({ type: "info", message: "请选择要修改的部门!" });
        }
        
      } else {
        if(this.organizationIdArr.idArr && this.organizationIdArr.idArr.length > 0) {
          this.handleDelEdit(null, 2)
        } else {
          this.$message({ type: "info", message: "请选择要修改的部门!" });
        }
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "./css/common.scss";
.organizationMain {
  height: 100%;
  margin-top: -10px;
  .rightAppManager {
    padding: 0;
    height: 100%;
    .AppManager-title {
      overflow: hidden;
      padding: 21px 7px;
      border-radius: 14px;
      line-height: 36px;
      .goBack {
        display: inline-block;
        line-height: 36px;
        font-size: 20px;
        cursor: pointer;
      }
      .iton {
        display: inline-block;
        vertical-align: top;
        margin-left: 14px;
        cursor: pointer;
        span {
          font-size: 14px;
          padding-left: 4px;
        }
        .add {
          font-size: 14px;
          color: #4e86ff;
        }
        .muban {
          font-size: 14px;
          color: #19b359;
        }
        .delete {
          font-size: 14px;
          color: #e47470;
        }
      }
    }
    .AppManager-list {
      width: calc(100% - 32px);
      height: calc(100% - 62px);
      padding: 16px;
      padding-bottom: 0;
      background: #fff;
      display: flex;
      flex-direction: column;
      .scrollArea {
        height: calc(100% - 96px);
      }
      &-todo {
        margin: 6px 0 16px 0;
        
      }
      &-title {
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        background-color: $table-bg-grey;
        color: $color-default;
        li {
          text-align: center;
          &:nth-of-type(1) {
            width: 48px;
          }
          &:nth-of-type(2) {
            text-align: left;
            flex: 1;
          }
          &:nth-of-type(3) {
            width: 140px;
          }
          &:nth-of-type(4) {
            width: 140px;
          }
          &:nth-of-type(5) {
            width: 140px;
          }
          &:nth-of-type(6) {
            width: 102px;
          }
          &:nth-of-type(7) {
            width: 93px;
          }
          &:nth-of-type(8) {
            width: 132px;
          }
          &:nth-of-type(9) {
            width: 200px;
          }
        }
      }
    }
  }
}
.newgroupBody{
  &-span-user{
    height: 32px;
    width: 100%;
    line-height: 32px;
    display: inline-block;
    box-sizing: border-box;
    color: #666;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    padding-left: 15px;
    background-color: #fff;
  }
}
.body-bottom {
  width: 100%;
  text-align: right;
  ::v-deep .el-button {
    padding: 7px 22px;
    .el-button--default {
      span {
        color: $color-gery;
      }
    }
  }
}
.disabled {
  background-color: #F5F7FA;
  color: #C0C4CC;
  &:hover {
    cursor: not-allowed;
  }
}
::v-deep.el-form {
  .el-form-item {
    margin-bottom: 16px;
    .el-form-item__label {
      padding-right: 8px;
      text-align: right;
      font-family: $text-family;
      color: $color-default;
    }
    .el-input {
      height: 32px;
      line-height: 32px;
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
  }
}
</style>
